
	
  if($(".smartrecruiters").length > 0){
	$.getScript( "https://static.smartrecruiters.com/job-widget/1.3.8/script/smart_widget.js", function() {
		 SmartRecruitersPlugin();
	});
  }


	function SmartRecruitersPlugin()
	{
		
		widget({
		"company_code": "EmbraceHomeLoansInc",
		"bg_color_widget": "#ffffff",
		"bg_color_headers": "#969696",
		"bg_color_links": "#55dd88",
		"txt_color_headers": "#292929",
		"txt_color_job": "#3d3d3d",
		"bg_color_even_row": "#e0e0e0",
		"bg_color_odd_row": "#f7f7f7",
		"auto_width": "auto",
		"auto_height": "auto",
		"number": "on",
		"job_title": "true",
		"location": "true",
		"jobAdType": "PUBLIC",
		"trid": "",
		"api_url": "https://www.smartrecruiters.com",
		"custom_css_url": "https://static.smartrecruiters.com/job-widget/1.3.8/css/smart_widget.css"
		});



	}
	